import { render } from "./BaseGeneralsPage.vue?vue&type=template&id=faf55754"
import script from "./BaseGeneralsPage.vue?vue&type=script&lang=js"
export * from "./BaseGeneralsPage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__